module.exports = __webpack_public_path__ + "img/small-ConvertBomb-icon.c406fe69.svg";